import React from 'react'

import { LoadingDots } from '@smarty-nx/ds'
import { Helmet } from 'react-helmet'

import classes from './redirect.module.scss'
import { Centered, SiteContainer } from '../../components/shared'

interface RedirectProps {
  pageContext: {
    toPath: string
  }
}
const Redirect: React.FC<RedirectProps> = ({ pageContext }) => {
  const { toPath } = pageContext

  return (
    <span>
      <Helmet>
        <meta httpEquiv="refresh" content={`0; URL='${toPath}'`} />
      </Helmet>
      <SiteContainer>
        <Centered margin="20vh auto 20vh">
          <div className={classes.redirect}>
            <div>
              <LoadingDots />
            </div>
            <p>We&apos;re redirecting you now...</p>
            <p>
              Click <a href={toPath}>this link</a> if you are not redirected
              automatically
            </p>
          </div>
        </Centered>
      </SiteContainer>
    </span>
  )
}

export default Redirect
